<script setup>
import SingleStep from '@/Components/FormSteps/SingleStep.vue';

defineProps({
    steps: Object,
    currentStep: Number,
})

</script>

<template>
    <nav :aria-label="$t('Progress')">
        <ol role="list"
            class="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0 bg-white">
            <li v-for="(step, stepIdx) in steps" :key="step.name" class="relative md:flex-1 md:flex">
                <SingleStep :step="step" :current-step="currentStep" :current-idx="stepIdx"></SingleStep>
                <template v-if="stepIdx !== steps.length - 1">
                    <!-- Arrow separator for lg screens and up -->
                    <div class="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                        <svg
                            :class="['h-full w-full', stepIdx < currentStep ? 'text-primary-500' : (stepIdx == currentStep ? 'text-primary-300' :'text-gray-300')]"
                            viewBox="0 0 22 80" fill="none"
                            preserveAspectRatio="none">
                            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor"
                                  stroke-linejoin="round"/>
                        </svg>
                    </div>
                </template>
            </li>
        </ol>
    </nav>
</template>